import { useContext } from 'react';
import { DeviceContext } from 'utils/Device/DeviceContext';

export default function TableWithContainerStyles() {
    const device = useContext(DeviceContext);

    return {
        Grid: {
            Item: {
                backgroundColor: "#f1f1f1",
                margin: device.isMobile ? "1em 0 1em 0" : "2em",
                padding: device.isMobile ? "1.5em 1em 0.75em 1em" : "3em 1.9em 1.5em 1.9em",
                position: "relative",
                textAlign: "center",
                width: "100%",
                minWidth: "325px"
            }
        },
        Title: {
            color: "#1d4c80",
            fontSize: device.isMobile ? "1.5em" : "1.8em",
            fontWeight: "bold"
        },
        Subtitle: {
            color: "#1d4c80",
            fontSize: device.isMobile ? "1.12em" : "1.25em",
            fontWeight: "bold",
            marginTop: device.isMobile ? "0.6em" : "1em"
        },
        Table: {
            FixedColumn: {
                textAlign: "left"
            },
            Header: {
                textAlign: "right"
            },
            Body: {
                textAlign: "right",
            },
            Footer: {
                textAlign: "right"
            }
        }
    };
};
